export default {"src":"/_next/static/media/logo.6137cd92.svg","height":331,"width":949};